export const styles = theme => ({
  textField: {
    width: "100%"
  },
  columnHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  icons: {
    display: "flex",
    alignItems: "center"
  },
  fab: {
    margin: 5,
    background: "#451476",
    color: "white",
    "&:hover": {
      background: "#591a99"
    }
  }
});
